export const STOCKOUT_PRODUCTS_FETCH = '[Stockout] Stockout Products Fetch'
export const STOCKOUT_PRODUCTS_FETCH_SUCCESS = '[Stockout] Stockout Products Fetch Success'
export const fetchStockoutProducts = () =>
  ({ type: STOCKOUT_PRODUCTS_FETCH })

export const STOCKOUT_PRODUCT_SAVE = '[Stockout] Stockout Product Save'
export const STOCKOUT_PRODUCT_SAVE_SUCCESS = '[Stockout] Stockout Product Save Success'
export const saveStockoutProduct = product =>
  ({ type: STOCKOUT_PRODUCT_SAVE, payload: product })